import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = React.memo(() => (
  <div
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </div>
));

export default Loading;
